import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { PaneComponent } from '@rocksoft/cdk';
import { AclGroupListComponent, AclMemberListComponent, NamedUserGroupAcl } from '@rocksoft/shared';

@Component({
  selector: 'era-group-permissions-entity-list-ui',
  templateUrl: './group-permissions-entity-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PaneComponent, AclGroupListComponent, AclMemberListComponent],
})
export class GroupPermissionsEntityListComponent {
  readonly acl = input<NamedUserGroupAcl>();
}
